import { TFunction } from "i18next";

export type ReconnectionProvider = "google" | "microsoft" | "zoom";

// Reasons meaning Zoom no longer grants the admin access Dreamhub needs, as
// opposed to the connection itself expiring or being revoked.
const ZOOM_ADMIN_ACCESS_REASONS: readonly string[] = [
  "missing_scopes",
  "role_lookup_denied"
];

/** Translated reconnect-banner copy for one connected-account provider. */
export const reconnectionBannerLabels = (
  t: TFunction<"translation", undefined>,
  provider: ReconnectionProvider,
  reason?: string | null
) => {
  if (provider === "zoom") {
    const variant =
      reason && ZOOM_ADMIN_ACCESS_REASONS.includes(reason)
        ? "adminAccessLost"
        : "expired";
    return {
      message: t(`zoomReconnectBanner.${variant}`),
      button: t("zoomReconnectBanner.button")
    };
  }
  const type = t(`connectedAccounts.serviceNames.${provider}`);
  return {
    message: t("reconnectBanner", { type }),
    button: t("reconnectButton", { type })
  };
};
